import { render, staticRenderFns } from "./TextInputAiAutofillV1Properties.vue?vue&type=template&id=b8db505a&"
import script from "./TextInputAiAutofillV1Properties.vue?vue&type=script&lang=js&"
export * from "./TextInputAiAutofillV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports